module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/90f5c01996c6a9142745d3845ab4eb9c.png";